/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misty_Sapphire_Penguin_DashInputs */

const en_misty_sapphire_penguin_dash = /** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred while attempting to load your subscriptions. Please contact support.`)
};

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const id_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const ms_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const ca_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const cs_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const da_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const de_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const et_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const es_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const fr_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const hr_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const it_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const lv_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const lt_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const hu_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const nl_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const nb_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const pl_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const pt_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const ro_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const sk_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const sl_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const fi_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const sv_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const vi_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const tr_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const el_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const bg_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const ru_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const sr_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const uk_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const ka_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const hi_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const th_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const ko_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const zh_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const zh_tw_misty_sapphire_penguin_dash = zh_misty_sapphire_penguin_dash;

/** @type {(inputs: Misty_Sapphire_Penguin_DashInputs) => LocalizedString} */
const ja_misty_sapphire_penguin_dash = en_misty_sapphire_penguin_dash;

/**
* | output |
* | --- |
* | "An error occurred while attempting to load your subscriptions. Please contact support." |
*
* @param {Misty_Sapphire_Penguin_DashInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const misty_sapphire_penguin_dash = /** @type {((inputs?: Misty_Sapphire_Penguin_DashInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misty_Sapphire_Penguin_DashInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misty_sapphire_penguin_dash(inputs)
	if (locale === "ms") return ms_misty_sapphire_penguin_dash(inputs)
	if (locale === "ca") return ca_misty_sapphire_penguin_dash(inputs)
	if (locale === "cs") return cs_misty_sapphire_penguin_dash(inputs)
	if (locale === "da") return da_misty_sapphire_penguin_dash(inputs)
	if (locale === "de") return de_misty_sapphire_penguin_dash(inputs)
	if (locale === "et") return et_misty_sapphire_penguin_dash(inputs)
	if (locale === "es") return es_misty_sapphire_penguin_dash(inputs)
	if (locale === "fr") return fr_misty_sapphire_penguin_dash(inputs)
	if (locale === "hr") return hr_misty_sapphire_penguin_dash(inputs)
	if (locale === "it") return it_misty_sapphire_penguin_dash(inputs)
	if (locale === "lv") return lv_misty_sapphire_penguin_dash(inputs)
	if (locale === "lt") return lt_misty_sapphire_penguin_dash(inputs)
	if (locale === "hu") return hu_misty_sapphire_penguin_dash(inputs)
	if (locale === "nl") return nl_misty_sapphire_penguin_dash(inputs)
	if (locale === "nb") return nb_misty_sapphire_penguin_dash(inputs)
	if (locale === "pl") return pl_misty_sapphire_penguin_dash(inputs)
	if (locale === "pt") return pt_misty_sapphire_penguin_dash(inputs)
	if (locale === "ro") return ro_misty_sapphire_penguin_dash(inputs)
	if (locale === "sk") return sk_misty_sapphire_penguin_dash(inputs)
	if (locale === "sl") return sl_misty_sapphire_penguin_dash(inputs)
	if (locale === "fi") return fi_misty_sapphire_penguin_dash(inputs)
	if (locale === "sv") return sv_misty_sapphire_penguin_dash(inputs)
	if (locale === "vi") return vi_misty_sapphire_penguin_dash(inputs)
	if (locale === "tr") return tr_misty_sapphire_penguin_dash(inputs)
	if (locale === "el") return el_misty_sapphire_penguin_dash(inputs)
	if (locale === "bg") return bg_misty_sapphire_penguin_dash(inputs)
	if (locale === "ru") return ru_misty_sapphire_penguin_dash(inputs)
	if (locale === "sr") return sr_misty_sapphire_penguin_dash(inputs)
	if (locale === "uk") return uk_misty_sapphire_penguin_dash(inputs)
	if (locale === "ka") return ka_misty_sapphire_penguin_dash(inputs)
	if (locale === "hi") return hi_misty_sapphire_penguin_dash(inputs)
	if (locale === "th") return th_misty_sapphire_penguin_dash(inputs)
	if (locale === "ko") return ko_misty_sapphire_penguin_dash(inputs)
	if (locale === "zh") return zh_misty_sapphire_penguin_dash(inputs)
	if (locale === "zh-tw") return zh_tw_misty_sapphire_penguin_dash(inputs)
	if (locale === "ja") return ja_misty_sapphire_penguin_dash(inputs)
	return en_misty_sapphire_penguin_dash(inputs)
});